
import { defineComponent } from "vue";
import { termsContent1, termsContent2 } from "./common";
import Doijiko from "./doi.vue";
import ChangeLog from "./changeLog.vue";

export default defineComponent({
  components: {
    Doijiko,
    ChangeLog,
  },
  setup() {
    const content1 = termsContent1.replaceAll("\n", "<br />");
    const content2 = termsContent2.replaceAll("\n", "<br />");
    return {
      content1,
      content2,
    };
  },
});
